// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3v5cM","productName":"Table_productName__3JTy6"};